export const GET_STUDENTS_LIST = "GET_STUDENTS_LIST";
export const GET_EXPENSE = "GET_EXPENSE";
export const ADD_EXPENSE = "ADD_EXPENSE";
export const GET_FEEDBACK = "GET_FEEDBACK";
export const ADD_FEEDBACK = "ADD_FEEDBACK";
export const DELETE_FEEDBACK = "DELETE_FEEDBACK";
export const GET_INCOME = "GET_INCOME";
export const ADD_INCOME = "ADD_INCOME";
